import {React, useEffect, useRef, useState} from 'react';
import {Button, Paper, Tooltip, Typography} from '@material-ui/core';
import DialogBox from '../components/DialogBox';
import download from './DownloadLink';
import reusableInputStyles from '../components/InputStyles';
import {useReactToPrint} from 'react-to-print';
import ComponentToPrint from './ComponentToPrint';
import LocalPrintshopOutlinedIcon from '@material-ui/icons/LocalPrintshopOutlined';
import GetAppSharpIcon from '@material-ui/icons/GetAppSharp';
import TelegramIcon from '@material-ui/icons/Telegram';
import PreviewFileEmail from './PreviewFileEmail';
import {ErrorSnackbar, SuccessSnackbar} from '../components/CustomSnackBar';
import {useDispatch, useSelector} from 'react-redux';
import {resetPreviewFile} from '../redux/reducers/PreviewFile';
import PageLoader from '../components/PageLoader';
import BreadCrums from './BreadCrum';

function PreviewFileDialog({
  open,
  dialogClose,
  fileUrl,
  configData,
  dockey,
  moduleName,
  dmExecution,
  name,
  code,
  description,
  descriptionValue,
}) {
  const classes = reusableInputStyles();
  const componentRef = useRef();
  const getDocumentTitle = (title) => {
    const n = title?.lastIndexOf('/');
    const result = title?.substring(n + 1);
    const finalResult = result?.substring(0, result?.indexOf('.'));
    return finalResult;
  };
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dockey ? getDocumentTitle(dockey) : '',
  });
  const {previewFileStatus, succesMsg, errorMsg} = useSelector(
    ({addPrviewFile}) => addPrviewFile,
  );
  const { successMsg: downloadSuccessMsg } = useSelector(({ previewFileData }) => previewFileData);
  const [downoadMsg, setDownloadMsg] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const handleDownload = () => {
    setLoader(true);
    setTimeout(() => {
      download(fileUrl);
      setDownloadMsg(true);
      setLoader(false);
    }, 2000);
  };

  useEffect(() => {
    if (downoadMsg && downloadSuccessMsg && loader) {
      setTimeout(() => {
        setDownloadMsg(false);
      }, 2000);
    }
  }, [downoadMsg, downloadSuccessMsg, loader]);

  useEffect(() => {
    if (previewFileStatus === 200 && !errorMsg) {
      setTimeout(() => {
        dispatch(resetPreviewFile());
        setEmailOpen(false);
      }, 2000);
    }
  }, [previewFileStatus, errorMsg]);
  useEffect(() => {
    if (succesMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetPreviewFile());
      }, 2000);
    }
  }, [succesMsg, errorMsg]);

  const [emailOpen, setEmailOpen] = useState(false);
  const handleEmailClose = () => {
    setEmailOpen(false);
  };
  return (
    <>
      <DialogBox
        open={open}
        dialogClose={dialogClose}
        title={dmExecution ? 'View Execution Audit Report' : 'View & Download Configuration'}
        maxWidth="xl"
        hideFooter={true}
        fileUrl={fileUrl}
        className="previewFile"
      >
        <div className="d-flex col justify-content-end new-standard-textfields mb-2">
          <Button
            type="button"
            variant="outlined"
            className={`search-btn ml-2 ${classes.buttonRoot}`}
            onClick={handleDownload}
          >
            <GetAppSharpIcon fontSize="small" />
            <Typography variant="inherit">Download</Typography>
          </Button>
          <div style={{display: 'none'}}>
            <ComponentToPrint ref={componentRef} configData={configData} />
          </div>
          <Tooltip
            title={`${
              configData?.data?.length > 1200000 ?
                'Print is not available as file size is too large, Please Download and Print' :
                ''
            }`}
          >
            <div>
              <Button
                type="button"
                variant="outlined"
                disabled={configData?.data?.length > 1200000}
                className={`search-btn ml-2 ${classes.buttonRoot}`}
                onClick={handlePrint}
              >
                <LocalPrintshopOutlinedIcon fontSize="medium" />
                <Typography variant="inherit">Print</Typography>
              </Button>
            </div>
          </Tooltip>
          <Button
            type="button"
            variant="outlined"
            className={`search-btn ml-2 ${classes.buttonRoot}`}
            onClick={() => {
              setEmailOpen(true);
            }}
          >
            <TelegramIcon fontSize="medium" />
            <Typography variant="inherit">Email</Typography>
          </Button>
        </div>
        {code && (
          <div className="ml-3">
            <BreadCrums
              name={name}
              code={code}
              description={description}
              descriptionValue={descriptionValue}
            />
          </div>
        )}
        <Paper className="px-4 pt-2 mx-2 paperViewFile">
          <pre className="previewData">{configData?.data || ''}</pre>
        </Paper>
      </DialogBox>
      <DialogBox open={emailOpen} dialogClose={handleEmailClose} title="Email" maxWidth="md">
        <PreviewFileEmail
          handleEmailClose={handleEmailClose}
          setEmailOpen={setEmailOpen}
          dockey={dockey}
          moduleName={moduleName}
        />
      </DialogBox>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {succesMsg && <SuccessSnackbar successMsg={succesMsg} />}
      {downoadMsg && <SuccessSnackbar successMsg={downloadSuccessMsg} />}
      {loader && <PageLoader />}
    </>
  );
}

export default PreviewFileDialog;
